exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Home .lander{color:#000;opacity:.9}.top-margin{margin-top:90px}.card-header{background-color:#00bcd4;box-shadow:2px 0 5px 0 rgba(0,0,0,.5)}.center-img{margin:-230px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/containers/Home.scss
// module id = ./node_modules/css-loader/index.js!./node_modules/sass-loader/lib/loader.js!./src/containers/Home.scss
// module chunks = 0